import { createReducer, on } from '@ngrx/store';
import { AccountInfoActions } from '../../account-info-header/actions';
import { actionLinkInfo, TableComponentState } from '../types/TableComponentState';
import { standingAuthTableTabName, standingAuthTableTabs, tableActions } from '../utilities/Constants';
import { AchActions, ConfirmationPageActions, StandingAuthorizationsActions, StandingAuthorizationsTableActions, TransactionFormActions, TransactionsTableActions } from '../../create-request/actions';
import { StandingAuthConfirmationPageActions, StandingAuthReviewPageActions } from '../../standing-authorizations/actions';
import { SharedActions } from '../actions';
import { ViewPageActions } from '../../transaction-view/actions';

export const standingAuthTableStateKey = 'standingAuthTableState';

export interface State extends TableComponentState {
  actionsLinkInfo: actionLinkInfo;
  addUpdateDeleteNickname: {
    nicknameCallSucceeded: boolean;
  },
  currentTab: standingAuthTableTabName | '';
}

export const initialStandingAuthTableState: State = {
  loading: false,
  error: '',
  hasError: false,
  gridReady: false,
  isInitialLoad: true,
  printClicked: false,
  actionsLinkInfo: {
    actionName: '',
    actionClicked: false,
    selectedRowData: {
      transactionType: '',
      transferDirection: '',
      standingAuthId: ''
    }
  },
  addUpdateDeleteNickname: {
    nicknameCallSucceeded: false
  },
  currentTab: '',
  hasEmptyResponse: false,
};

export const standingAuthTableStateReducer = createReducer(
  initialStandingAuthTableState,
  on(StandingAuthorizationsTableActions.gridReady, (state, action) => {
    return {
      ...state,
      gridReady: action.gridReady,
      currentTab: standingAuthTableTabs.all
    };
  }),
  on(
    AccountInfoActions.loadTransactions,
    StandingAuthorizationsTableActions.refresh,
    TransactionsTableActions.refresh,
    ConfirmationPageActions.viewTransactionStatusClicked,
    ConfirmationPageActions.createAnotherRequestClicked,
    StandingAuthConfirmationPageActions.createNewStandingAuthClicked,
    StandingAuthConfirmationPageActions.returnStandingAuthClicked,
    (state) => {
      return {
        ...state,
        loading: true,
        error: '',
        hasError: false,
      };
    }
  ),
  on(StandingAuthorizationsTableActions.deleteTransactionClicked, (state) => {
    return {
      ...state,
      loading: true,
      error: '',
      hasError: false,
      cancelLinkClicked: true
    }
  }),
  on(AccountInfoActions.updateSubAccount, (state) => {
    return {
      ...state
    }
  }),
  on(AccountInfoActions.loadTransactionsSuccess,
    AchActions.deleteProfileFromReviewPageSuccessful,
    StandingAuthorizationsTableActions.deleteTransactionFailure,
    StandingAuthorizationsTableActions.deleteTransactionFailurePendingTransaction,
    (state) => {
      return {
        ...state,
        isInitialLoad: false,
        loading: false,
        hasError: false,
        cancelLinkClicked: false
      };
  }),
  on(AccountInfoActions.loadTransactionsFailure, (state, err) => {
    return {
      ...state,
      isInitialLoad: false,
      loading: false,
      error: err.message,
      hasError: true,
      cancelLinkClicked: false
    };
  }),
  on(StandingAuthorizationsTableActions.printClicked, (state) => {
    return {
      ...state,
      printClicked: true
    };
  }),
  on(TransactionsTableActions.printClicked, (state) => {
    return {
      ...state,
      printClicked: false
    };
  }),
  on(
    StandingAuthorizationsTableActions.startTransactionClicked,
    (state, { rowData }) => {
      return {
        ...state,
        actionsLinkInfo: {
          actionName: tableActions.startTransaction,
          actionClicked: true,
          selectedRowData: rowData
        }
      };
    }
  ),
  on(
    StandingAuthorizationsTableActions.editProfileClicked,
    TransactionsTableActions.editProfileClicked,
    ViewPageActions.editProfileClicked,
    (state, { rowData }) => {
      return {
        ...state,
        actionsLinkInfo: {
          actionName: tableActions.edit,
          actionClicked: true,
          selectedRowData: rowData
        }
      };
    }
  ),
  on(
    StandingAuthorizationsTableActions.startTransacionFlowComplete,
    StandingAuthorizationsActions.loadSloasFailure,
    StandingAuthorizationsTableActions.editTransactionFlowComplete,
    StandingAuthReviewPageActions.editCompleted,
    (state) => {
      return {
        ...state,
        actionsLinkInfo: initialStandingAuthTableState.actionsLinkInfo,
      };
    }
  ),
  on(TransactionFormActions.transactionTypeChanged, (state) => {
    return {
      ...state,
      actionsLinkInfo: initialStandingAuthTableState.actionsLinkInfo,
    };
  }),
  on(
    StandingAuthorizationsTableActions.addUpdateDeleteNickname,
    StandingAuthorizationsTableActions.addUpdateDeleteNicknameFailure,
    (state) => {
      return {
        ...state,
        addUpdateDeleteNickname: {
          nicknameCallSucceeded: false,
        },
      };
    }
  ),
  on(
    StandingAuthorizationsTableActions.addUpdateDeleteNicknameSuccess,
    (state) => {
      return {
        ...state,
        addUpdateDeleteNickname: {
          nicknameCallSucceeded: true,
        },
      };
    }
  ),
  on(StandingAuthorizationsTableActions.currentTabUpdated, (state, {currentTab}) => {
    return {
      ...state,
      currentTab: currentTab
    }
  }),
  on(SharedActions.hasEmptyResponse, (state) => {
    return {
      ...state,
      hasEmptyResponse: true,
    }
  })
);

